export default __webpack_public_path__ + "static/2406-d176134fbb7dfef624145174de5add13.gif";